/**
 * [载单限制]
 * @Author: Fu Xiaochun
 * @Email:  f2e.xiaochun@gmail.com
 */

import React from 'react';
import { Modal } from 'antd';
import PropTypes from 'prop-types';
import styles from './OrderLimitModal.module.scss';
import { XTextArea, XInputNum } from '@/components/xqxc_ui';
import { message } from 'antd';
import http from '@/assets/api/http';

class OrderLimit extends React.Component {

    state = {
        confirmLoading: false,
        count: undefined, // 接单数量
    }

    componentDidMount(){
        if(this.props.item.id){
            this.setState({count: this.props.item.acceptNum});
        }
    }

    _handleOk = () => {
        const { ids } = this.props;
        const { count } = this.state;
        if (!this._isHaveValue(count)) {
            message.warning('请输入限制接单数量');
            return false;
        }

        let params = {
            ids,
            acceptNum: count ===  0 ? 9999 : count
        };
        let apiUrl = '/?cmd=com.xqxc.api.pig.mis.biz.account.RiderAccountMisService.setAcceptNum';
        http(apiUrl, params, 'POST').then(() => {
                message.success('设置成功！');
                this.props.closeModal(true);
            }).catch((e) => {
                message.error(e.message);
            });
    }

    // 检查是否有输入数字
    _isHaveValue = (val) => {
        if (val === '' || val === null || val === undefined) {
            return false;
        } else {
            return true;
        }
    }

    _handleCancel = () => {
        this.props.closeModal();
    }

    render() {
        const { confirmLoading, count } = this.state;

        return (
            <Modal
                width={600}
                centered
                title='载单限制'
                open={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <XInputNum
                        style={{ marginTop: '10px' }}
                        label='载单限制'
                        placeholder='请输入接单数量'
                        value={count}
                        bindThis={this}
                        bindName='count'
                        precision={0}
                        suffix='单'
                        min={0}
                        max={9999}
                        isRequired={true}
                    />
                    <div className={styles.tips}>
                        1、设置骑手最多可同时接取的配送单数量，不限制时输入0；<br />
                        2、当超过该处设置的单量时提示：您当前最多可同时接取X单；设定后立即执行。
                    </div>
                </div>
            </Modal>
        );
    }
}

OrderLimit.propTypes = {
    ids: PropTypes.array, // 弹窗传递参数
    item: PropTypes.object,
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default OrderLimit;